/* @flow */
import { em } from 'polished';
import type { ThemeFunction } from 'src/shared/app/base/types/themeTypes';

export default {
  icon: {
    width: 111,
    height: 111,
    color: ({ theme }: ThemeFunction) => theme.accentColor,
    padding: 16,
    marginBottom: em(6),
  },
};
